import { loadBlocks, BLOCKS } from './blocks';
import {
  loadUserRoles,
  USER_ROLES,
} from '../../../main/utils/factories/userRoles';
import { setMomentLocale } from '../../../main/utils/factories/moment';
import { loadDocumentTypes } from '../../../main/utils/factories/documentTypes';
import { loadChatGroups } from '../../../main/utils/factories/chatGroups';

export const buildAdminFactories = (locales) => {
  loadBlocks(locales);
  loadUserRoles(locales);
  setMomentLocale(locales);
  loadDocumentTypes(locales);
  loadChatGroups(locales);
};

export { BLOCKS, USER_ROLES };
